import React, {useState, useRef, useEffect} from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Card from 'react-bootstrap/Card'
import {Form} from 'react-bootstrap'
import AutoUpdateInputFields from './AutoUpdateInputFields'
import {GroupDetailsContext} from '../../../../context/Modal/GroupDetails'
import {AuditValidateAutoUpdateForm} from '../../../../utils/AuditValidateForm'
import {AuditModalBarContext} from '../../../../context/AuditModalBar'
import {AuditModalApiContext} from '../../../../context/AuditModalApi'
import {withTranslation} from 'react-i18next'
import {AuditPaneContext} from '../../../../context/AuditPane'

function usePrevious(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value //assign the value of ref to the argument
  }, [value]) //this code will run when the value of 'value' changes
  return ref.current //in the end, return the current ref value.
}

function CustomAutoUpdateField(props) {
  const [states, setStates] = useState({
    search: [...props.fields],
    changeDefaultCaret: false,
    autoSaveState: false,
    errors: [],
  })
  const AccordionElement = React.useRef(null)
  const {audit_entities_attributes, setGroupDetails, setAllowAutoUpdateField} = React.useContext(
    GroupDetailsContext
  )

  const {entities, getEntityAutoFieldsValues} = React.useContext(AuditModalApiContext)

  const modalBar = React.useContext(AuditModalBarContext)
  const paneState = React.useContext(AuditPaneContext)

  const auto_update_fields_values = entities.entities.entities_details
    ? entities.entities.entities_details[0].auto_update_fields_values
    : []

  let prevProp = usePrevious(props.values)

  useEffect(() => {
    if (
      audit_entities_attributes[0].audit_entity_auto_update_fields_attributes.length > 0 &&
      (paneState.modalType === 'edit' || paneState.modalType === 'duplicate')
    ) {
      var fieldIds = audit_entities_attributes[0].audit_entity_auto_update_fields_attributes.map(
        i => {
          return i.field_id
        }
      )
      getEntityAutoFieldsValues(audit_entities_attributes[0].entity_id, fieldIds)
    }
    //eslint-disable-next-line
  }, [])

  const checkSelectAll = (e, value) => {
    const isSelectAll = value === 'select_all' && e.target.checked
    const isDeselectAll = value === 'select_all'
    return {isSelectAll, isDeselectAll}
  }

  const getFields = (defaultArr, arr, obj, props1, props2, props3) => {
    let myArr = []
    let myArr2 = arr.filter(myObj => myObj[props1] + '' === obj[props2] + '')

    myArr2.map(c => {
      if (c.is_parent) {
        myArr = [...myArr, ...arr.filter(myObj => myObj[props1] + '' === c[props3] + '')]
      }
      return true
    })
    return [...defaultArr, ...myArr2, ...myArr]
  }
  const handleAutoUpdateCheckboxChange = (e, filter) => {
    let fieldArr = []
    let fieldObj = []
    let newArr = [...audit_entities_attributes]

    if (checkSelectAll(e, filter.field_id).isSelectAll) {
      fieldArr = props.fields.map(autoField => {
        return {
          field_name: autoField.field_name,
          field_id: autoField.field_id,
          field_type: autoField.field_type,
          values: autoField.values,
          is_parent: autoField.is_parent,
          parent_id: autoField.parent_id,
          value_id: '',
          value_name: '',
          is_required: autoField.is_required,
        }
      })
      fieldArr.push(filter)
    } else if (checkSelectAll(e, filter.field_id).isDeselectAll) {
      fieldArr = []
    } else {
      if (e.target.checked) {
        if (filter.is_parent) {
          fieldObj = getFields(fieldObj, props.fields, filter, 'parent_id', 'field_id', 'field_id')
        }

        // if (filter.parent_id !== '') {
        //   fieldObj = getFields(fieldObj, props.fields, filter, 'value_id', 'parent_id', 'parent_id')
        // }
        var tFields = [],
          fieldID = []
        tFields = audit_entities_attributes[props.index].audit_entity_auto_update_fields_attributes

        fieldObj.map(i => {
          if (i.field_id !== filter.field_id) {
            fieldArr.push(i)
          }
          return true
        })

        tFields.map(i => {
          fieldID.push(i.field_id)
          return true
        })

        fieldArr.map(function(e) {
          if (tFields.length > 0) {
            if (!fieldID.includes(e.field_id)) tFields.push(e)
          } else {
            tFields.push(e)
          }
          return true
        })
        tFields.push(filter)
        fieldArr = tFields
        if (fieldArr.length === props.fields.length) {
          fieldArr.push({
            field_id: 'select_all',
            field_name: 'Select All',
            field_type: 'select_type',
            values: [],
          })
        }
      } else {
        if (filter.is_parent) {
          fieldObj = getFields(fieldObj, props.fields, filter, 'parent_id', 'field_id', 'field_id')
        }
        let index = [],
          fieldID = []

        fieldObj.map(field => {
          fieldID.push(field.field_id)
          return true
        })
        fieldID.push(filter.field_id)

        tFields = audit_entities_attributes[props.index].audit_entity_auto_update_fields_attributes
        tFields.map(function(e) {
          if (fieldID.length > 0) {
            if (e.field_id !== 'select_all') {
              if (!fieldID.includes(e.field_id)) index.push(e)
            }
          } else if (e.field_id !== filter.field_id) {
            index.push(e)
          }
          return true
        })

        fieldArr = index
      }
    }

    audit_entities_attributes[props.index].audit_entity_auto_update_fields_attributes = fieldArr
    var a = audit_entities_attributes[props.index].audit_entity_user_fields_attributes
    if (a.length > 0) {
      var c = a.filter(function(objFromA) {
        return !fieldArr.find(function(objFromB) {
          return objFromA.field_id === objFromB.field_id
        })
      })
      audit_entities_attributes[props.index].audit_entity_user_fields_attributes = c
    }
    setGroupDetails(newArr)
  }

  const handleNextSaveAutoUpdateFieldBox = () => {
    var fieldIds = audit_entities_attributes[0].audit_entity_auto_update_fields_attributes.map(
      i => {
        return i.field_id
      }
    )

    getEntityAutoFieldsValues(audit_entities_attributes[0].entity_id, fieldIds)

    // let newArr = [...audit_entities_attributes]
    //   audit_entities_attributes[props.index].audit_entity_auto_update_fields_values = auto_update_fields_values
    //   setGroupDetails(newArr)

    if (states.autoSaveState) {
      AuditValidateAutoUpdateForm(props.values).then(err => {
        if (err.length === 0) {
          setStates({...states, autoSaveState: false})
          AccordionElement.current.click()
        } else {
          setStates({...states, errors: err})
        }
      })
    } else {
      setStates({...states, autoSaveState: true})
    }
  }

  const handlePrevSaveAutoUpdateFieldBox = () => {
    setStates({...states, autoSaveState: false})
    // this.props.clearAutoSaveErrors()
  }

  const handleClearAutoUpdateCheckbox = () => {
    let newArr = [...audit_entities_attributes]
    audit_entities_attributes[props.index].audit_entity_auto_update_fields_attributes = []
    setGroupDetails(newArr)
    setAllowAutoUpdateField(false)
  }

  const handleSearch = e => {
    let fields = []
    if (e.target.value === '') fields = [...props.fields]
    else
      fields = props.fields.filter(k =>
        k.field_name.toLowerCase().match(e.target.value.toLowerCase())
      )
    setStates({...states, search: fields})
  }

  const changeCaret = () => {
    if (states.changeDefaultCaret === false) {
      setStates({...states, changeDefaultCaret: true, autoSaveState: false})
    } else {
      setStates({...states, changeDefaultCaret: false, autoSaveState: false})
    }
  }

  const renderSelectedLabel = (placeholderButtonLabel, value) => {
    if (!value) return placeholderButtonLabel
    if (!Array.isArray(value)) return value.field_name
    if (value.length === 0) return placeholderButtonLabel
    if (value.length > 3) {
      return (
        <div className="css-1v99tuv">
          {value.slice(0, 3).map(val => {
            return <span className="selected-data">{val.field_name}</span>
          })}
          <span className="selected-data-3">+{value.length - 3}</span>
        </div>
      )
    }
    return (
      <div className="css-1v99tuv">
        {value.map(val => {
          return <span className="selected-data">{val.field_name}</span>
        })}
      </div>
    )
  }

  const handleAutoFieldChange = fieldData => {
    if (props.values.length > 0) {
      let autoFieldArr = []
      props.values.map(field => {
        if (field.field_id === fieldData.field_id) {
          field.value_name = fieldData.value_name ? fieldData.value_name : null
          field.value_id = fieldData.value_id ? fieldData.value_id : null
          autoFieldArr.push(field)
        } else {
          autoFieldArr.push(field)
        }
        return true
      })
      let newArr = [...audit_entities_attributes]
      audit_entities_attributes[
        props.index
      ].audit_entity_auto_update_fields_attributes = autoFieldArr
      setGroupDetails(newArr)
    }
  }

  const getFieldNameLabel = filter => {
    let labelName = filter.field_name
    let parentName = null
    let childName = null

    if (filter.is_parent) {
      let parentField = props.fields.filter(
        myObj =>
          myObj?.parent_id &&
          myObj.parent_id.toString() === filter?.field_id &&
          filter.field_id.toString()
      )
      parentField.map(parent => {
        parentName = parentName ? `${parentName}, ${parent.field_name}` : parent.field_name
        if (parent.is_parent) {
          let childField = props.fields.filter(
            myObj => myObj.parent_id.toString() === parent.field_id.toString()
          )
          childField.map(child => {
            childName = childName ? `${childName}, ${child.field_name}` : child.field_name
            return true
          })
        }
        return true
      })

      if (parentName) {
        labelName = `${labelName} / ${parentName}`
      }
      if (childName) {
        labelName = `${labelName} / ${childName}`
      }
    }

    return labelName
  }

  const handleAutoMultipleFieldChange = fieldData => {
    if (props.values.length > 0) {
      let temp_auto_updates_attributes = props.values
      let index
      props.values.map(field => {
        if (field.field_id === fieldData.field_id) {
          index = temp_auto_updates_attributes
            .map(function(e) {
              return e.field_id
            })
            .indexOf(fieldData.field_id)
          temp_auto_updates_attributes = temp_auto_updates_attributes.filter((_, i) => i !== index)
        }
        return true
      })

      if (fieldData.selectedOptions.length > 0) {
        fieldData.selectedOptions.map(k => {
          let multi_tempfield = {
            field_id: fieldData.field_id,
            field_name: fieldData.field_name,
            field_type: fieldData.field_type,
            is_parent: fieldData.is_parent,
            parent_id: fieldData.parent_id,
            selectedOptions: [],
            selectedValues: [],
            value_id: k.value ? k.value : null,
            value_name: k.label ? k.label : null,
            values: fieldData.values,
          }
          temp_auto_updates_attributes.splice(index, 0, multi_tempfield)
          return true
        })
      } else {
        let single_tempfield = {
          field_id: fieldData.field_id,
          field_name: fieldData.field_name,
          field_type: fieldData.field_type,
          is_parent: fieldData.is_parent,
          parent_id: fieldData.parent_id,
          selectedOptions: [],
          selectedValues: [],
          value_id: '',
          value_name: '',
          values: fieldData.values,
        }
        temp_auto_updates_attributes.splice(index, 0, single_tempfield)
      }

      let newArr = [...audit_entities_attributes]
      audit_entities_attributes[
        props.index
      ].audit_entity_auto_update_fields_attributes = temp_auto_updates_attributes
      setGroupDetails(newArr)
    }
  }

  const {t} = props
  let autoUpdateFields = states.search

  if (props.fields.length > 0) {
    autoUpdateFields = [
      {field_id: 'select_all', field_name: 'Select All', field_type: 'select_type', values: []},
      ...autoUpdateFields,
    ]
  }

  // eslint-disable-next-line array-callback-return
  let optionItems = autoUpdateFields.map(autoField => {
    if (autoField.parent_id === '') {
      let isChecked = false
      if (props.values.len3gth === props.fields.length) {
        isChecked = true
      } else {
        props.values.map(selctedField => {
          if (
            selctedField.field_id.toString() === autoField.field_id.toString() &&
            selctedField.field_name === autoField.field_name
          ) {
            isChecked = true
          }
          return true
        })
      }
      return (
        <Form.Check
          type="checkbox"
          className="filter_ckeckbox"
          label={getFieldNameLabel(autoField)}
          onChange={e => {
            handleAutoUpdateCheckboxChange(e, {
              field_name: autoField.field_name,
              field_id: autoField.field_id,
              field_type: autoField.field_type,
              values: autoField.values,
              is_parent: autoField.is_parent,
              parent_id: autoField.parent_id,
              value_id: '',
              value_name: '',
              is_required: autoField.is_required,
            })
            modalBar.setEditWarning(true)
          }}
          checked={isChecked}
        />
      )
    }
  })

  const isChildFilled = (parentField, allFields) => {
    let flag = false
    if (
      parentField.value_name ||
      (parentField.selectedValues && parentField.selectedValues.length)
    ) {
      allFields.map(field => {
        if (field.parent_id === parentField.field_id + '') {
          if (field.value_id || (parentField.selectedValues && field.selectedValues.length)) {
            flag = false
          } else {
            flag = true
          }
        }
        return true
      })
    }
    return flag
  }

  const isParentFilled = (parentId, allFields) => {
    let flag = false
    if (parentId === '') {
      return false
    }
    allFields.map(field => {
      if (field.field_id + '' === parentId) {
        if (field.value_name || (field.selectedValues && field.selectedValues.length)) {
          flag = false
        } else {
          flag = true
        }
      }
      return true
    })

    return flag
  }

  const getParentValue = (parentId, allFields) => {
    let selectedValue = ''
    if (parentId === '') {
      return ''
    }
    allFields.map(field => {
      if (field.field_id + '' === parentId) {
        if (field.value_name) {
          selectedValue = field.value_id
        } else if (field.selectedValues && field.selectedValues.length) {
          selectedValue = field.selectedValues
        }
      }
      return true
    })

    return selectedValue
  }
  return (
    <Accordion
      defaultActiveKey={0}
      className={
        states.changeDefaultCaret
          ? 'collapsible_section overflow-auto styled_checkbox mt-7 autoUpdateField box-shadow'
          : 'collapsible_section overflow-auto styled_checkbox mt-7 autoUpdateField'
      }
    >
      <Card className="first_card">
        <Accordion.Toggle
          as={Button}
          variant=""
          ref={AccordionElement}
          onClick={() => changeCaret()}
          eventKey="002"
        >
          {props.values.length === 0
            ? 'Select Update Fields'
            : !states.autoSaveState
            ? renderSelectedLabel('Select Update Fields', props.values)
            : 'Input Field Values'}

          <span className={states.changeDefaultCaret ? 'display_none' : 'display_block'}>
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
              className="css-6q0nyr-Svg"
            >
              <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
            </svg>
          </span>
          <span className={states.changeDefaultCaret ? 'display_block' : 'display_none'}>
            <svg
              className="MuiSvgIcon-root cross"
              focusable="false"
              viewBox="-5 -3 30 30"
              aria-hidden="true"
              role="presentation"
            >
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
            </svg>
          </span>
        </Accordion.Toggle>
      </Card>
      <Accordion.Collapse style={{margin: 10, marginTop: 0, marginBottom: 0}} eventKey="002">
        <div>
          {!states.autoSaveState && (
            <Form.Control type="text" placeholder="Search" onChange={e => handleSearch(e)} />
          )}
          {!states.autoSaveState ? (
            optionItems.length > 0 ? (
              <div className="auto_field_height">{optionItems}</div>
            ) : (
              <div class="auto_field_no_option">No options</div>
            )
          ) : (
            <div className="auto_field_height_save">
              {entities.isAutoFieldValueLoading ? (
                <div className="loader-height-44">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <>
                  {props.values.length > 0 &&
                    props.values.map(k => {
                      let disabled = isParentFilled(k.parent_id, props.values)
                      let parentValue = getParentValue(k.parent_id, props.values)
                      let field_value
                      field_value = auto_update_fields_values.find(x => x.field_id === k.field_id)
                      k.values = field_value.values
                      return (
                        <>
                          {k.is_parent && isChildFilled(k, props.values) ? (
                            <div className="auto-text-danger">
                              {' '}
                              Updating this field may cause data loss. Add its child or unselect to
                              prevent data loss.
                            </div>
                          ) : null}
                          <label className={'width-100-persent'}>{k.field_name}</label>

                          <AutoUpdateInputFields
                            all_field_data={props.values}
                            field_data={k}
                            handleFieldChange={e => handleAutoFieldChange(e)}
                            handleMultipleFieldChange={e => handleAutoMultipleFieldChange(e)}
                            errors={states.errors}
                            disabled={disabled}
                            parentValue={parentValue}
                          />
                        </>
                      )
                    })}
                </>
              )}
            </div>
          )}
          <div className="top_border">
            <div
              className={props.values.length > 0 ? 'btn primary_btn' : 'btn primary_btn disabled'}
              onClick={props.values.length > 0 ? () => handleNextSaveAutoUpdateFieldBox() : null}
            >
              {states.autoSaveState ? t('audit.form-create-auto-update-fields.save') : 'Next'}
            </div>
            <div
              className="btn default_btn"
              onClick={
                !states.autoSaveState
                  ? () => handleClearAutoUpdateCheckbox()
                  : () => handlePrevSaveAutoUpdateFieldBox()
              }
            >
              {!states.autoSaveState ? 'Cancel' : 'Back'}
            </div>
          </div>
        </div>
      </Accordion.Collapse>
    </Accordion>
  )
}

export default withTranslation()(CustomAutoUpdateField)
